import React, { Component } from "react";
import { Field, Formik, Form } from "formik";
import { ClipLoader } from "react-spinners";
import DatePicker from "react-datepicker";
import * as moment from "moment";
import swal from "sweetalert";
import { service as oetService } from "../../oet/redux";

class RunReportComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoadig: false
        };
    }
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-8">
                        <Formik
                            initialValues={{
                                start_date: null,
                                end_date: null,
                                oet_id: "",
                                oet_name: "",
                                cpo_numbers: ""
                            }}
                            onSubmit={values => this.handleSubmit(values)}
                        >
                            {props => {
                                const { values, setFieldValue } = props;
                                return (
                                    <Form>
                                        <div className="form-group">
                                            <label>Start date</label>
                                            <Field
                                                component={DatePicker}
                                                dateFormat="dd/MM/yyyy"
                                                onChange={value => setFieldValue("start_date", value, false)}
                                                name="start_date"
                                                autoComplete="off"
                                                selected={values.start_date}
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>End date</label>
                                            <Field
                                                component={DatePicker}
                                                dateFormat="dd/MM/yyyy"
                                                onChange={value => setFieldValue("end_date", value, false)}
                                                name="end_date"
                                                autoComplete="off"
                                                selected={values.end_date}
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>OET ID</label>
                                            <Field name="oet_id" className="form-control" />
                                        </div>
                                        <div className="form-group">
                                            <label>OET Name</label>
                                            <Field name="oet_name" className="form-control" />
                                        </div>
                                        <div className="form-group">
                                            <label>CPO List</label>
                                            <Field name="cpo_numbers" className="form-control" />
                                        </div>
                                        <button type="submit" className="btn btn-success float-right">
                                            Download
                                        </button>
                                        {this.state.isLoadig && (
                                            <div className="float-right">
                                                <ClipLoader />
                                            </div>
                                        )}
                                    </Form>
                                );
                            }}
                        </Formik>
                    </div>
                </div>
            </div>
        );
    }

    handleSubmit = values => {
        const request = { ...values };
        request.start_date = moment(values.start_date)
            .format("DD/MM/YYYY")
            .replace("Invalid date", "");
        request.end_date = moment(values.end_date)
            .format("DD/MM/YYYY")
            .replace("Invalid date", "");
        const errorMessage = () =>
            swal({
                title: "Warning ...",
                text: "An error has occurred while trying to download the report",
                icon: "warning",
                button: true
            });
        this.setState({ isLoadig: true });
        oetService
            .runReport(request)
            .then(_ => this.setState({ isLoadig: false }))
            .catch(_ => {
                this.setState({ isLoadig: false });
                errorMessage();
            });
    };
}

export default RunReportComponent;
